import { api } from '@shared/config/axios';

export default {
  getConfiguration() {
    return api.$get('/mcp/configuration');
  },
  getConsentContext(params) {
    return api.$get('/mcp/oauth/consent-context', { params });
  },
  approveConsent(payload) {
    return api.$post('/mcp/oauth/consent', payload);
  },
  denyConsent(payload) {
    return api.$post('/mcp/oauth/consent/deny', payload);
  },
  getConnections() {
    return api.$get('/mcp/connections');
  },
  revokeConnection(clientId, userUuid = null) {
    return api.$delete('/mcp/connections', {
      params: { client_id: clientId, ...(userUuid ? { user_uuid: userUuid } : {}) },
    });
  },
};
